const accountToken = (state) => state.token;
const accountPrivilege = (state) => state.accountDetails.privilege;

const status = (state) => state.status;

const farms = (state) => state.farms;

const currentFarmId = (state) => state.currentFarmId;

const currentFarm = (state) => state.farms[state.currentFarmId];

const currentFarmName = (state) => state.farms[state.currentFarmId]?.name;

const currentFarmUnits = (state) => state.currentFarmUnits;

const currentFarmSchedules = (state) =>
  state.farms[state.currentFarmId]?.schedules;

const currentFarmMapLayer = (state) => state.currentFarmMapLayer;

const currentFarmUnit = (state) => (unit_mac) => {
  for (const [id, enduser] of Object.entries(
    state.farms[state.currentFarmId].endusers
  )) {
    let obj = enduser.units[unit_mac];

    if (obj) {
      return { mac: unit_mac, enduser_id: id, ...obj };
    }
  }

  return null;
};

const currentRegions = (state) => state.farms[state.currentFarmId].regions;

const currentTerrains = (state) => state.farms[state.currentFarmId].terrains;

export {
  accountToken,
  accountPrivilege,
  status,
  farms,
  currentFarmId,
  currentFarm,
  currentFarmName,
  currentFarmUnits,
  currentFarmSchedules,
  currentFarmMapLayer,
  currentFarmUnit,
  currentRegions,
  currentTerrains,
};
